module.exports = __webpack_public_path__ + "media/images/front/icons/groups-2bb0a056e6a558deb54f7ede265e2627.png";